import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/arrow-customize-builder-back.svg'
import _imports_1 from '@/assets/icons/arrow-customize-builder.svg'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["steppy", { end: $setup.isFirstStep, 'not-first': $props.isNotFirstStep }])
  }, [
    _createElementVNode("button", {
      class: _normalizeClass(["button button-prev", { 'hidden-first-step': $setup.isFirstStep }]),
      onClick: $setup.onSelectPrev
    }, [
      _cache[0] || (_cache[0] = _createElementVNode("img", {
        class: "reverse",
        src: _imports_0
      }, null, -1)),
      _createElementVNode("span", null, _toDisplayString($setup.backStepTextButton), 1)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["current-step", { 'has-error': $props.errorOnCurrentStep }])
    }, [
      _createElementVNode("span", null, _toDisplayString($setup.BUILDER_ESTIMATOR_STEPS_MAP[$props.currentStep]), 1)
    ], 2),
    _createElementVNode("button", {
      class: _normalizeClass(["button button-next", { 'next-disabled': $setup.nextButtonIsDisabled }]),
      onClick: $setup.onSelectNext
    }, [
      _createElementVNode("span", null, _toDisplayString($setup.nextStepTextButtonControlled), 1),
      _cache[1] || (_cache[1] = _createElementVNode("img", {
        class: "next",
        src: _imports_1
      }, null, -1))
    ], 2)
  ], 2))
}